import React, { Component } from 'react';
import styled from 'styled-components';

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(["\n      background: ", ";\n      width: ", "px;\n      height: ", "px;\n      border-radius: 50%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    "], ["\n      background: ", ";\n      width: ", "px;\n      height: ", "px;\n      border-radius: 50%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    "]),
    _templateObject2 = taggedTemplateLiteral(["\n      width: ", "px;\n      height: ", "px;\n      border-radius: 50%;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n      border-radius: 50%;\n    "]);

var index = function (_Component) {
  inherits(index, _Component);

  function index() {
    classCallCheck(this, index);
    return possibleConstructorReturn(this, (index.__proto__ || Object.getPrototypeOf(index)).apply(this, arguments));
  }

  createClass(index, [{
    key: "render",
    value: function render() {
      var Div = styled.div(_templateObject, this.props.roundedColor, this.props.imageWidth, this.props.imageHeight);
      var Img = styled.img(_templateObject2, this.props.imageWidth - this.props.roundedSize, this.props.imageHeight - this.props.roundedSize);
      return React.createElement(Div, null, React.createElement(Img, {
        alt: "",
        src: this.props.image
      }));
    }
  }]);
  return index;
}(Component);

index.defaultProps = {
  imageWidth: "200",
  imageHeight: "200",
  roundedSize: "20",
  roundedColor: "#1B3D50"
};
export default index;